import { MobileOfferCatalogEntry, MobileOfferProvider, MobileOfferStatus, MobileOfferStoreStatus } from '@numeo/types'

export type AssignmentStoreSelection = MobileOfferProvider | 'both'

export function assignmentStores(selection: AssignmentStoreSelection): MobileOfferProvider[] {
    return selection === 'both' ? ['apple', 'google'] : [selection]
}

export function isReviewedStoreOfferCurrent(current: MobileOfferCatalogEntry, reviewed: MobileOfferCatalogEntry, provider: MobileOfferProvider): boolean {
    return (
        current.status === MobileOfferStatus.ACTIVE &&
        current.stores[provider].status === MobileOfferStoreStatus.READY &&
        JSON.stringify(current.terms) === JSON.stringify(reviewed.terms) &&
        JSON.stringify(current.stores[provider]) === JSON.stringify(reviewed.stores[provider])
    )
}
